<template>
    <q-layout style="background: #f1f2f4" view="hHh lpR fFf">
        <q-dialog v-model="dialogSubirExcel" persistent>
            <q-card style="min-width: 700px;">
                <q-bar class="bg-primary text-white">
                    <div>Cargar Excel</div>
                    <q-space />

                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>

                <q-card-section class="text-right">
                    <div class="row">
                        <div class="col-12 col-md-12">
                            <q-input filled type="file" accept=".xlsx, .xls" @change="onFileAdded" />
                        </div>
                        <div class="col-12 col-md-12 q-my-md">
                            <q-btn color="primary" icon="mdi-delete" label="Borrar" @click="dataE = []" />
                            <q-btn class="q-ml-sm" color="primary" icon="mdi-content-save" label="Cargar"
                                @click="postCargarExcel()" />
                        </div>

                        <div class="col-12 col-md-12">
                            <q-table dense :data="dataE" :columns="columnsE" row-key="name"
                                :pagination="{ rowsPerPage: 10 }">

                                <template v-slot:body="props">
                                    <q-tr :props="props">
                                        <q-td key="zona" :props="props">
                                            {{ props.row.zona }}
                                        </q-td>
                                        <q-td key="codigo_postal" :props="props">
                                            {{ props.row.codigo_postal }}
                                        </q-td>
                                    </q-tr>
                                </template>
                            </q-table>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="confirm" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <q-avatar icon="mdi-alert" color="primary" text-color="white" />
                    <span class="q-ml-sm">Estas seguro de eliminar la Zona {{ itemZona.zona }} con Código Postal {{
                        itemZona.codigo_postal }} ?</span>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn flat label="Cerrar" color="primary" v-close-popup />
                    <q-btn flat label="Eliminar" color="primary" @click="DeleteZonasCP()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog full-width v-model="dialogoImpresion" persistent>
            <q-card class="shadow-0">
                <q-bar class="bg-primary text-white">
                    <q-icon color="white" name="mdi-account" />
                    <div>Diligencias por Zona y Usuario</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section class="q-col-gutter-sm">
                    <div class="row">
                        <q-select style="width: 20%;" dense filled v-model="model" use-input hide-selected fill-input
                            input-debounce="0" :options="filterUsuarios" @filter="filterFn" option-label="nombre"
                            label="Nombre de usuario">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section class="text-grey">
                                        No results
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>

                        <q-select class="q-ml-md" style="width: 20%;" dense filled v-model="zonaI" option-label="zona"
                            :options="dataZonas" label="Zona">
                            <template v-slot:no-option>
                                <q-item>
                                    <q-item-section class="text-grey">
                                        No results
                                    </q-item-section>
                                </q-item>
                            </template>
                            <template v-slot:after>
                                <q-btn round color="primary" icon="mdi-magnify" @click="getListaVisitasGeneral()">
                                    <q-tooltip>
                                        Actualizar Lista
                                    </q-tooltip>
                                </q-btn>
                            </template>
                        </q-select>
                        <q-space />
                        <q-input v-model="fehaIMasked" filled label="Fecha límite de pago" name="event" outlined dense>
                            <template v-slot:before>
                                <q-icon name="event" color="primary" />
                            </template>
                            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                <q-date v-model="fecha_pago">
                                    <div class="row items-center justify-end">
                                        <q-btn v-close-popup label="Ok" color="primary" flat />
                                    </div>
                                </q-date>
                            </q-popup-proxy>
                        </q-input>
                        <q-btn color="primary" icon="mdi-printer" label="Imprimir Variables"
                            @click="exportPDFVariables()" class="q-mr-md"></q-btn>
                        <q-btn color="primary" icon="mdi-printer" label="Imprimir" @click="exportPDF()"></q-btn>
                    </div>
                    <div class="col-12">
                        <q-bar dense class="bg-primary text-white">
                            <q-space />
                            <div>DILIGENCIAS</div>
                            <q-space />
                        </q-bar>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-table dense :data="dataI" :columns="columnsI" row-key="name" :filter="filterI"
                            :loading="loadingI" :pagination="{ rowsPerPage: 10 }">
                            <template v-slot:top-right>
                                <q-input borderless dense debounce="300" v-model="filterI" placeholder="Buscar">
                                    <template v-slot:append>
                                        <q-icon name="search" />
                                    </template>
                                </q-input>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props">

                                    <q-td key="folio" :props="props">
                                        {{ props.row.folio }}
                                    </q-td>
                                    <q-td key="nombre" :props="props">
                                        {{ props.row.deudor.nombre }}
                                    </q-td>
                                    <q-td key="tipovisita" :props="props">
                                        {{ props.row.tipo_visita }}
                                    </q-td>
                                    <q-td key="codigo_postal" :props="props">
                                        {{ props.row.deudor.codigo_postal }}
                                    </q-td>
                                    <q-td key="municipio_deudor" :props="props">
                                        {{ props.row.deudor.municipio_deudor }}
                                    </q-td>
                                    <q-td key="localidad" :props="props">
                                        {{ props.row.deudor.localidad }}
                                    </q-td>
                                    <q-td key="fraccionamiento_colonia" :props="props">
                                        {{ props.row.deudor.fraccionamiento_colonia }}
                                    </q-td>
                                    <q-td key="calle" :props="props">
                                        {{ props.row.deudor.calle }}
                                    </q-td>
                                    <q-td key="fecha_visita" :props="props">
                                        {{ props.row.fecha_visita }}
                                    </q-td>
                                    <q-td key="usuario" :props="props">
                                        {{ props.row.usuario.usuario }}
                                    </q-td>
                                    <q-td key="estatus" :props="props">
                                        <q-badge v-if="props.row.estatus == 'Asignado'" color="purple">
                                            {{ props.row.estatus }}
                                        </q-badge>
                                        <q-badge v-else-if="props.row.estatus == 'visitado'" color="green">
                                            {{ props.row.estatus }}
                                        </q-badge>
                                        <q-badge v-else-if="props.row.estatus == 'Cancelada'" color="red">
                                            {{ props.row.estatus }}
                                        </q-badge>
                                        <q-badge v-else color="blue">
                                            {{ props.row.estatus }}
                                        </q-badge>
                                    </q-td>
                                    <q-td key="notas" :props="props">
                                        {{ props.row.notas }}
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat label="Cerrar" color="primary" v-close-popup />
                    <q-btn flat label="Asignar" color="primary" @click="postAsignar()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO PARA RE ASIGNAR A OTRO USUARIO -->
        <q-dialog v-model="dialogZonasAsignar" persistent>
            <q-card class="shadow-0" style="width: 100%;">
                <q-bar class="bg-primary text-white">
                    <q-icon color="white" name="mdi-account" />
                    <div>Asginar Zonas</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section class="q-col-gutter-sm">
                    <q-select dense filled v-model="zonaAsignar" option-label="zona" fill-input :options="dataZonas"
                        label="Zona">
                        <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-grey">
                                    No results
                                </q-item-section>
                            </q-item>
                        </template>
                        <template v-slot:after>
                            <q-btn round color="primary" icon="mdi-send" @click="postAsignar()">
                                <q-tooltip>
                                    Actualizar Lista
                                </q-tooltip>
                            </q-btn>
                        </template>
                    </q-select>
                    <div class="col-12">
                        <q-bar dense class="bg-primary text-white">
                            <q-space />
                            <div>CÓDIGOS POSTALES</div>
                            <q-space />
                        </q-bar>
                    </div>
                    <q-table class="q-mt-sm shadow-0" dense :data="itemsCodigosPostales" :columns="columnsCP"
                        row-key="codigo_postal" :filter="filterCP" :loading="loadingCP"
                        :pagination="{ rowsPerPage: 10 }" selection="multiple" :selected.sync="cpSeleccionados">
                        <template v-slot:top-right>
                            <q-input filled dense debounce="300" v-model="filterCP" placeholder="Buscar">
                                <template v-slot:append>
                                    <q-icon name="search" />
                                </template>
                            </q-input>
                        </template>
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width>
                                    <q-checkbox v-model="props.selected"></q-checkbox>
                                </q-td>
                                <q-td key="codigo_postal" :props="props">
                                    {{ props.row.codigo_postal }}
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat label="Cerrar" color="primary" v-close-popup />
                    <q-btn flat label="Asignar" color="primary" @click="postAsignar()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALGOO PARA CREAR UN NUEVO TIPO DE VISITA -->
        <q-dialog v-model="dialogZonas" persistent>
            <q-card>
                <q-bar class="bg-primary text-white">
                    <q-icon color="white" name="mdi-account" />
                    <div>Zonas</div>
                    <q-space />

                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>

                <q-card-section class="q-col-gutter-sm">
                    <q-input filled dense v-model="zona" placeholder="Zona" label="Zona" @keyup.enter="postZona()">
                        <template v-slot:after>
                            <q-btn color="green" round dense icon="mdi-plus" @click="postZona()" />
                        </template>
                    </q-input>
                    <q-table class="shadow-0 q-mt-sm" dense :data="dataZonas" :columns="columnsZonas"
                        :pagination="{ rowsPerPage: 10 }" row-key="_id" :loading="loadingZonas"></q-table>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="q-pa-xl q-mx-smq-gutter-sm">
            <q-card class="shadow-0" style="width: 100%;">
                <q-card-section full-width class=" text-white">
                    <div class="row">
                        <q-toolbar class="q-mb-md">
                            <q-btn color="primary" icon="mdi-plus" label="Asignación de Zonas"
                                @click="abrirAsignacion()" />
                            <q-btn class="q-ml-sm" color="primary" icon="mdi-file-excel" label="Cargar Excel"
                                @click="cargarExcel" />
                            <q-btn class="q-ml-sm" round color="primary" icon="mdi-cog" @click="abrirZonas()">
                                <q-tooltip>
                                    Zonas
                                </q-tooltip>
                            </q-btn>
                            <q-space />
                            <q-btn color="primary" icon="mdi-printer" label="Imprimir"
                                @click="abrirDialogoImpresion()"></q-btn>
                            <q-btn round color="primary" class="q-ml-md" icon="mdi-magnify"
                                @click="getListaZonasAsignadas()">
                                <q-tooltip>
                                    Actualizar Lista
                                </q-tooltip>
                            </q-btn>
                        </q-toolbar>
                        <div class="col-12 col-md-12">
                            <q-table dense :data="data" :columns="columns" row-key="name" title="Zonas" :filter="filter"
                                :loading="loading" :pagination="{ rowsPerPage: 10 }">
                                <template v-slot:top-right>
                                    <q-input borderless dense debounce="300" v-model="filter" placeholder="Buscar">
                                        <template v-slot:append>
                                            <q-icon name="search" />
                                        </template>
                                    </q-input>
                                </template>
                                <template v-slot:body="props">
                                    <q-tr :props="props">
                                        <q-td key="actions" :props="props">

                                            <q-btn flat round color="red" icon="mdi-delete-empty"
                                                @click="eliminar(props.row)">
                                                <q-tooltip>
                                                    Eliminar
                                                </q-tooltip>
                                            </q-btn>
                                        </q-td>
                                        <q-td key="zona" :props="props">
                                            {{ props.row.zona }}
                                        </q-td>
                                        <q-td key="codigo_postal" :props="props">
                                            {{ props.row.codigo_postal }}
                                        </q-td>
                                    </q-tr>
                                </template>
                            </q-table>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </div>
    </q-layout>
</template>
<script>
import axios from 'axios'
import { QSpinnerGrid } from 'quasar'
import * as XLSX from 'xlsx';
import moment from 'moment';
import { FormatoNotificacionPDF } from '../PDF/FormatoNotificacionPDF.js'
import { FormatoNotificacionVariablesPDF } from '../PDF/FormatoNotificacionVariablesPDF.js'
// import { FormatoNotificacionPDF } from '../../components/Main/PDF/FormatoNotificacionPDF.js'
export default {
    name: 'Home',
    components: {
    },
    data() {
        return {
            columns: [
                { name: 'actions', align: 'center', label: 'Acciones', field: 'actions', sortable: true, style: 'max-width: 50px', },
                {
                    name: 'zona',
                    field: 'zona',
                    required: true,
                    label: 'Zona',
                    align: 'center',
                    sortable: true,
                    classes: 'bg-grey-2 ellipsis',
                    headerClasses: 'bg-primary text-white'
                },
                { name: 'codigo_postal', align: 'center', label: 'Código Postal', field: 'codigo_postal', sortable: true },
            ],
            data: [],
            filter: '',
            loading: false,

            dataZonas: [],
            loadingZonas: false,
            columnsZonas: [
                {
                    name: 'zona',
                    field: 'zona',
                    required: true,
                    label: 'Zona',
                    align: 'center',
                    sortable: true,
                    classes: 'bg-grey-2 ellipsis',
                    style: 'max-width: 100px',
                    headerClasses: 'bg-primary text-white'
                },
            ],
            dialogZonas: false,
            zona: '',

            dialogZonasAsignar: false,
            itemsCodigosPostales: [],
            filterCP: '',
            loadingCP: false,
            cpSeleccionados: [],
            columnsCP: [{
                name: 'codigo_postal',
                field: 'codigo_postal',
                required: true,
                label: 'Código Postal',
                align: 'center',
                sortable: true,
                classes: 'bg-grey-2 ellipsis',
                style: 'max-width: 100px',
                headerClasses: 'bg-primary text-white'
            },],
            zonaAsignar: { zona: '' },
            dialogoImpresion: false,

            columnsI: [
                // { name: 'actions', align: 'center', label: 'Acciones', field: 'actions', sortable: true },
                {
                    name: 'folio',
                    field: 'folio',
                    required: true,
                    label: 'Folio',
                    align: 'center',
                    sortable: true,
                    classes: 'bg-grey-2 ellipsis',
                    style: 'max-width: 100px',
                    headerClasses: 'bg-primary text-white'
                },
                { name: 'nombre', align: 'left', label: 'Contribuyente', field: 'nombre', sortable: true },
                { name: 'tipovisita', align: 'center', label: 'Tipo de Diligencia', field: 'tipovisita', sortable: true },
                { name: 'codigo_postal', align: 'center', label: 'Código Postal', field: 'codigo_postal' },
                { name: 'municipio_deudor', align: 'center', label: 'Municipio', field: 'municipio_deudor' },
                { name: 'localidad', align: 'center', label: 'Localidad', field: 'localidad' },
                { name: 'fraccionamiento_colonia', align: 'center', label: 'Fraccionamiento o Colonia', field: 'fraccionamiento_colonia' },
                { name: 'calle', align: 'center', label: 'Calle', field: 'calle' },
                { name: 'fecha_visita', align: 'center', label: 'Fecha de Diligencia', field: 'fecha_visita' },
                { name: 'usuario', align: 'center', label: 'Usuario', field: 'usuario' },
                { name: 'estatus', align: 'center', label: 'Estatus', field: 'estatus' },
                { name: 'notas', align: 'center', label: 'Notas', field: 'notas' },
            ],
            dataI: [],
            filterI: '',
            loadingI: false,
            filterUsuarios: [],
            model: { nombre: '' },
            usuarios: [],
            zonaI: '',
            dialogSubirExcel: false,
            columnsE: [
                {
                    name: 'zona',
                    field: 'zona',
                    required: true,
                    label: 'Zona',
                    align: 'center',
                    sortable: true,
                    classes: 'bg-grey-2 ellipsis',
                    style: 'max-width: 100px',
                    headerClasses: 'bg-primary text-white'
                },
                { name: 'codigo_postal', align: 'center', label: 'Código Postal', field: 'codigo_postal', sortable: true },
            ],
            dataE: [],
            fecha_pago: new Date(),
            confirm: false,
            itemZona: {
                zona: '',
                codigo_postal: ''
            }
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },
        itemsUsuarios() {
            return this.usuarios.filter(x => x.estatus == 'activo' && x.tipo == 'Movil');
        },
        fehaIMasked() {
            moment.locale('es-mx');
            return this.fecha_pago ? moment.utc(this.fecha_pago).format('DD/MMMM/yyyy') : ''
        },
    },
    created() {
        this.getListaZonasAsignadas()
    },
    methods: {
        async postCargarExcel() {
            if (this.dataE.length == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Asegurese que la lista contenga información.' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 120, message: 'Asignando Zonas. Espere...', messageColor: 'white' })

            try {
                let response = await axios.post("TipoVisita/PostCodigosPostales", this.dataE);
                console.log(response)
                this.$q.loading.hide()
                this.getListaZonasAsignadas()
                this.dataE = []
                this.dialogSubirExcel = false
            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },
        async postAsignar() {
            if (this.zonaAsignar.zona == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Zona.' })
                return;
            }

            if (this.cpSeleccionados.length == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione al menos un Código Postal.' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 120, message: 'Asignando Zonas. Espere...', messageColor: 'white' })
            let lista = [];
            for (var a of this.cpSeleccionados) {
                let objeto = {
                    zona: this.zonaAsignar.zona,
                    codigo_postal: a.codigo_postal
                }
                lista.push(objeto)
            }
            try {
                let response = await axios.post("TipoVisita/PostCodigosPostales", lista);
                console.log(response)
                this.$q.loading.hide()
                this.getListaZonasAsignadas()
                this.GetCodigosPostales()
                this.cpSeleccionados = []
            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

        async postZona() {
            if (this.zona == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la Zona.' })
                return;
            }

            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 120, message: 'Creando una nueva Zona. Espere...', messageColor: 'white' })

            let objeto = {
                zona: this.zona,
            }

            try {
                let response = await axios.post("TipoVisita/CreateZona", objeto);
                console.log(response)
                this.$q.loading.hide()
                this.getListaZonas()
                this.zona = ''

            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },
        async getListaZonas() {
            this.loadingZonas = true
            try {
                let response = await axios.get("TipoVisita/GetZonas");
                this.dataZonas = response.data;
                this.loadingZonas = false
            } catch (error) {
                console.log(error);
                this.loadingZonas = false
            }
        },

        async GetCodigosPostales() {
            this.loadingCP = true
            try {
                let response = await axios.get("TipoVisita/GetCodigosPostales");
                this.itemsCodigosPostales = response.data;
                this.loadingCP = false
            } catch (error) {
                console.log(error);
                this.loadingCP = false
            }
        },

        async getListaZonasAsignadas() {
            this.loading = true
            try {
                let response = await axios.get("TipoVisita/GetZonasAsignadas");
                this.data = response.data;
                this.loading = false
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },
        async getListaUsuarios() {
            try {
                let response = await axios.get("Usuarios/GetUsuarios");
                this.usuarios = response.data.lista;
            } catch (error) {
                console.log(error);
            }
        },
        async getListaVisitasGeneral() {
            this.loadingI = true
            console.log(this.model)
            console.log(this.zonaI)
            try {
                let response = await axios.post("Visita/GetVisitasXCodigoPostalUsuario/" + this.zonaI.zona + '/' + this.model.nombre);
                this.dataI = response.data;
                this.loadingI = false
            } catch (error) {
                console.log(error);
                this.loadingI = false
            }
        },

        abrirZonas() {
            this.getListaZonas()
            this.dialogZonas = true
        },

        abrirAsignacion() {
            this.getListaZonas()
            this.GetCodigosPostales()
            this.dialogZonasAsignar = true
        },
        abrirDialogoImpresion() {
            this.getListaZonas()
            this.getListaUsuarios()
            this.dialogoImpresion = true
        },
        filterFn(val, update, abort) {
            update(() => {
                const needle = val.toLocaleLowerCase()
                this.filterUsuarios = this.itemsUsuarios.filter(v => v.nombre.toLocaleLowerCase().indexOf(needle) > -1)
            },
                ref => {
                    if (val !== '' && this.filterUsuarios.length > 0) {
                        ref.setOptionIndex(-1)
                        ref.moveOptionSelection(1, true)
                    }
                }
            )
        },

        onFileAdded(event) {
            console.log(event)
            let columns = [];
            let tableData = [];
            const file = event.target.files[0]; // Obtener el archivo del input
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                // Asumir que la primera hoja es la deseada
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                // Convertir la hoja a JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                // Transformar los datos para q-table
                if (jsonData.length) {
                    columns = jsonData[0].map((header, index) => ({
                        name: index,
                        align: 'left',
                        label: header,
                        field: row => row[index],
                        sortable: true
                    }));
                    tableData = jsonData.slice(1).map((row, index) => ({
                        id: index,
                        ...row
                    }));

                    for (let c of tableData) {
                        console.log(c)
                        let objeto = {
                            zona: c['0'],
                            codigo_postal: c['1']
                        }
                        this.dataE.push(objeto)

                    }
                }
            };

            reader.readAsArrayBuffer(file); // Leer el archivo como ArrayBuffer
        },
        cargarExcel() {
            this.dialogSubirExcel = true
        },
        async exportPDF() {
            console.log(this.dataI)
            let fechaPago = moment(this.fecha_pago).format('YYYY/MM/DD')
            const pdfBase64 = await FormatoNotificacionPDF(fechaPago, this.dataI);
            const fileName = 'ReporteVisitasPDF_Usuario_' + this.model.nombre + '_' + this.zonaI.zona + '_Fecha_' + fechaPago + '.pdf';
            const link = document.createElement("a");
            link.href = pdfBase64;
            link.download = fileName;
            link.click();
        },

        async exportPDFVariables() {
            let fechaPago = moment(this.fecha_pago).format('YYYY/MM/DD')
            const pdfBase64 = await FormatoNotificacionVariablesPDF(fechaPago, this.dataI);
            const fileName = 'ReporteVisitasPDF_Usuario_' + this.model.nombre + '_' + this.zonaI.zona + '_Fecha_' + fechaPago + '.pdf';
            const link = document.createElement("a");
            link.href = pdfBase64;
            link.download = fileName;
            link.click();
        },

        eliminar(item) {
            this.itemZona = item
            this.confirm = true
        },
        async DeleteZonasCP() {
            console.log(this.itemZona)
            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 120, message: 'Eliminando visita. Espere...', messageColor: 'white' })
            try {
                let response = await axios.post("TipoVisita/DeleteZonasCP/" + this.itemZona._id);
                console.log(response)
                this.$q.loading.hide()
                this.getListaZonasAsignadas()
                this.confirm = false
            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        }
    }
}
</script>